import type { ReactNode } from "react";

type AuthPageShellProps = {
  children: ReactNode;
  className?: string;
};

export function AuthPageShell({ children, className }: AuthPageShellProps) {
  const contentClassName = ["w-full max-w-sm space-y-6 px-4", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className={contentClassName}>{children}</div>
    </div>
  );
}
